export default __webpack_public_path__ + "static/media/vivek-bindra.33358030.svg";